function getPartScore(currentPart:number, partIndex:number, partScore:number): string {
    return currentPart > partIndex ? partScore.toString() : "-";
}

export { getPartScore };